"use client";

import { SquareTerminalIcon } from "lucide-react";

import type { BashCodeExecutionToolResultContentBlock } from "../../types";
import { cn, truncate } from "../../utils";
import { CollapsibleSection } from "../CollapsibleSection";

interface BashResultBlockProps {
  block: BashCodeExecutionToolResultContentBlock;
  isStreaming?: boolean;
}

export const BashResultBlock = ({
  block,
  isStreaming,
}: BashResultBlockProps) => {
  const inner = block.content;
  const isError = inner.type?.endsWith("_error");
  const output = isError
    ? `${inner.error_code}: ${inner.error_message}`
    : `${inner.stdout || ""}${inner.stderr ? `\nSTDERR: ${inner.stderr}` : ""}`;

  return (
    <CollapsibleSection
      icon={<SquareTerminalIcon className="h-3 w-3" />}
      label="Bash Result"
      preview={truncate(output)}
      copyContent={output}
      isStreaming={isStreaming}
    >
      <pre
        className={cn(
          "overflow-x-auto whitespace-pre-wrap break-words rounded-md bg-zinc-100 p-2 text-xs",
          isError ? "text-red-600" : "text-zinc-800",
        )}
      >
        {output}
      </pre>
    </CollapsibleSection>
  );
};
